module.exports = __webpack_public_path__ + "vc.71968d8c7bc19416b455.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/vc.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/vc.svg
// module chunks = styles